import { Exception } from './exception';

export class AbortedException extends Exception {}
